/* unplugin-vue-components disabled */import script from "./DataCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataCell.vue?vue&type=script&setup=true&lang=ts"

import "./DataCell.vue?vue&type=style&index=0&id=1f608be4&lang=less"

const __exports__ = script;

export default __exports__